document.querySelectorAll('.accordion-header').forEach(header => {
  header.addEventListener('click', function () {
    const content = document.getElementById('acc-' + this.dataset.acc);
    content.classList.toggle('active');

    const head = document.getElementById('headacc-' + this.dataset.acc);
    head.classList.toggle('activehead');
  });
});

// Tab - Scoped to each product-tabs container
document.addEventListener("DOMContentLoaded", function () {
  const tabContainers = document.querySelectorAll(".product-tabs");

  tabContainers.forEach(container => {
    const buttons = container.querySelectorAll(".tab-button");
    const contents = container.querySelectorAll(".tab-content");

    buttons.forEach(button => {
      button.addEventListener("click", () => {
        // Remove active classes only within this container
        buttons.forEach(b => b.classList.remove("active"));
        contents.forEach(c => c.classList.remove("active"));

        // Activate clicked tab within this container
        button.classList.add("active");
        const targetTab = container.querySelector("#" + button.dataset.tab);
        if (targetTab) {
          targetTab.classList.add("active");
        }
      });
    });
  });
});

// Slider
document.addEventListener("DOMContentLoaded", function () {
  var slider = document.querySelector('.multi-image-slider');
  if (slider && slider.querySelectorAll('.slider-item').length > 1) {
    $(slider).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      autoplay: false
    });
  }
});

// Custom Scrollbar
document.querySelectorAll('.product-specifications-block, .product-cover').forEach(container => {
  // Find all scroll-content/scrollbar/thumb sets within this container
  const scrollContents = container.querySelectorAll('.scroll-content');
  const scrollbars = container.querySelectorAll('.custom-scrollbar');
  const thumbs = container.querySelectorAll('.custom-thumb');

  // Loop through all sets by index
  for (let i = 0; i < scrollContents.length; i++) {
    const content = scrollContents[i];
    const scrollbar = scrollbars[i];
    const thumb = thumbs[i];

    if (!content || !scrollbar || !thumb) continue;

    function updateThumb() {
      if (content.scrollWidth <= content.clientWidth) {
        scrollbar.style.display = 'none';
        return;
      } else {
        scrollbar.style.display = 'block';
      }

      const visibleRatio = content.clientWidth / content.scrollWidth;
      const thumbWidth = Math.max(scrollbar.clientWidth * visibleRatio, 30);
      thumb.style.width = `${thumbWidth}px`;

      const scrollRatio = content.scrollLeft / (content.scrollWidth - content.clientWidth);
      thumb.style.left = `${(scrollbar.clientWidth - thumbWidth) * scrollRatio}px`;
    }

    content.addEventListener('scroll', updateThumb);
    window.addEventListener('resize', updateThumb);

    // Grab & drag the content
    let isDraggingContent = false, startX, startScrollLeft;
    content.addEventListener('mousedown', e => {
      if (content.scrollWidth <= content.clientWidth) return;
      isDraggingContent = true;
      startX = e.pageX;
      startScrollLeft = content.scrollLeft;
      content.style.cursor = 'grabbing';
      e.preventDefault();
    });

    document.addEventListener('mousemove', function mouseMoveContent(e) {
      if (!isDraggingContent) return;
      const dx = e.pageX - startX;
      content.scrollLeft = startScrollLeft - dx;
    });

    document.addEventListener('mouseup', function mouseUpContent() {
      if (isDraggingContent) {
        isDraggingContent = false;
        content.style.cursor = 'grab';
      }
    });

    // Dragging the thumb
    let isDraggingThumb = false, thumbStartX, thumbStartLeft;
    thumb.addEventListener('mousedown', e => {
      isDraggingThumb = true;
      thumbStartX = e.pageX;
      thumbStartLeft = parseInt(window.getComputedStyle(thumb).left, 10) || 0;
      document.body.style.userSelect = 'none';
      e.preventDefault();
    });

    document.addEventListener('mousemove', function mouseMoveThumb(e) {
      if (!isDraggingThumb) return;
      const dx = e.pageX - thumbStartX;
      const maxThumbLeft = scrollbar.clientWidth - thumb.offsetWidth;
      let newLeft = Math.min(Math.max(0, thumbStartLeft + dx), maxThumbLeft);
      thumb.style.left = `${newLeft}px`;

      const scrollRatio = newLeft / maxThumbLeft;
      content.scrollLeft = (content.scrollWidth - content.clientWidth) * scrollRatio;
    });

    document.addEventListener('mouseup', function mouseUpThumb() {
      if (isDraggingThumb) {
        isDraggingThumb = false;
        document.body.style.userSelect = '';
      }
    });

    // Initial update
    updateThumb();
  }
});